import React, { useState } from "react";
import { Link } from "react-router-dom";
import { TypeAnimation } from "react-type-animation";
import Banner1 from "../../assets/images/banavt1.png";
import Banner2 from "../../assets/images/banavt2.png";
import Banner3 from "../../assets/images/banavt3.png";
import Banner4 from "../../assets/images/play.svg";
import Banner5 from "../../assets/images/googleplay.png";
import Banner6 from "../../assets/images/appstorebtn.png";
import Banner7 from "../../assets/images/smallStar.png";
import Banner8 from "../../assets/images/bigstar.png";
import Banner9 from "../../assets/images/bannerScreen.png";
import Screen1 from "../../assets/images/bannerScreen2.png";
import Screen2 from "../../assets/images/bannerScreen3.png";
import Icon from "../../assets/images/iphonescren.png";
import Icon1 from "../../assets/images/12mtext.png";
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css";
import { Pagination } from "swiper/modules";
import "swiper/css/pagination";
import "swiper/css/navigation";

const Slidernew = {
  responsive: {
    0: {
      items: 1,
    },
    600: {
      items: 1,
    },
    1000: {
      items: 1,
    },
  },
};

function Banner() {
  const [ytban, setytban] = useState(false);

  return (
    <>
      <section className="banner_section">
        <div className="container">
          <div className="row">
            <div
              className="col-lg-6 col-md-12"
              data-aos="fade-up"
              data-aos-duration={1500}
            >
              <div className="banner_text">
                <div className="type-wrap">
                  <TypeAnimation
                    id="typed"
                    sequence={[
                      "Orientation ",
                      500,
                      "Coaching IA ",
                      500,
                      "Évolution personnelle ",
                      500,
                    ]}
                    style={{ whiteSpace: "pre" }}
                    repeat={Infinity}
                  />
                </div>
                <h1>
                  Découvre qui tu es vraiment.{" "}
                  <span>Construis ton futur avec Neoori.</span>
                </h1>
                <p>
                  Neoori t’aide à mieux te connaître grâce à un coach IA
                  personnalisé, des tests intelligents, des jeux d’exploration
                  et des recommandations adaptées à ton profil.
                </p>
              </div>

              <div className="used_app">
                <ul>
                  <li>
                    <img src={Banner1} alt="" />
                  </li>
                  <li>
                    <img src={Banner2} alt="" />
                  </li>
                  <li>
                    <img src={Banner3} alt="" />
                  </li>
                  <li>
                    <Link
                      to="#"
                      className="popup-youtube play-button"
                      data-url="https://www.youtube.com/embed/tgbNymZ7vqY?autoplay=1&mute=1"
                      data-toggle="modal"
                      data-target="#myModal"
                      title="XJj2PbenIsU"
                      onClick={() => setytban(true)}
                    >
                      <img src={Banner4} alt="img" />
                    </Link>
                  </li>
                </ul>
                {/**
                   * 
                   <h3>12M + Active users</h3>
                   <p>
                      The best application to manage your <br /> customer worldwide
                  </p>
                   * 
                   * 
                   */}
              </div>

              <ul className="app_btn">
                <li>
                  <Link to="#">
                    <img className="blue_img" src={Banner5} alt="" />
                  </Link>
                </li>
                <li>
                  <Link to="#">
                    <img className="blue_img" src={Banner6} alt="" />
                  </Link>
                </li>
              </ul>
            </div>
            <div className="col-lg-6 col-md-12">
              <div className="banner_slider">
                <div className="left_icon">
                  <img src={Banner7} alt="" />
                </div>
                <div className="right_icon">
                  <img src={Banner8} alt="" />
                </div>
                <Swiper
                  id="frmae_slider"
                  className="mySwiper"
                  slidesPerView={1}
                  autoplay={true}
                  pagination={true}
                  modules={[Pagination]}
                  {...Slidernew}
                >
                  <SwiperSlide className="item">
                    <div className="slider_img">
                      <img src={Banner9} alt="" />
                    </div>
                  </SwiperSlide>
                  <SwiperSlide className="item">
                    <div className="slider_img">
                      <img src={Screen1} alt="" />
                    </div>
                  </SwiperSlide>
                  <SwiperSlide className="item">
                    <div className="slider_img">
                      <img src={Screen2} alt="" />
                    </div>
                  </SwiperSlide>
                </Swiper>
                <div className="slider_frame">
                  <img src={Icon} alt="" />
                </div>
              </div>
            </div>
          </div>
          <div
            className="spinBlock"
            data-aos="fade-up"
            data-aos-duration={1500}
          >
            <span className="star">
              <img src={Banner7} alt="" />
            </span>
            <div className="spin_box" id="scrollButton">
              <span className="downsign">
                <i className="icofont-long-arrow-down" />
              </span>
              <div className="spin-text">
                <img src={Icon1} alt="" />
              </div>
            </div>
            <span className="star">
              <img src={Banner7} alt="" />
            </span>
          </div>
        </div>
      </section>

      {ytban && (
        <div
          className="modal fade youtube-video show"
          id="myModal"
          tabIndex={-1}
          style={{ display: "block", paddingRight: 17 }}
          aria-modal="true"
          role="dialog"
        >
          <div className="modal-dialog" role="document">
            <div className="modal-content" onClick={() => setytban(false)}>
              <button
                id="close-video"
                type="button"
                className="button btn btn-default text-right"
                data-dismiss="modal"
                onClick={() => setytban(false)}
              >
                <i className="icofont-close-line-circled" />
              </button>
              <div className="modal-body">
                <div id="video-container" className="video-container">
                  <iframe
                    id="youtubevideo"
                    title="Youtube Video Player"
                    width={640}
                    height={360}
                    allowFullScreen=""
                    src="https://www.youtube.com/embed/tgbNymZ7vqY?autoplay=1&mute=1"
                  />
                </div>
              </div>
              <div className="modal-footer"></div>
            </div>
          </div>
        </div>
      )}
    </>
  );
}

export default Banner;
